<!--  Loader Ends -->
<!-- Main Body Starts -->
<div class="container-fluid login-two-container">
  <div class="row main-login-two">
    <div class="col-xl-6 col-lg-6 col-md-6 d-none d-md-block p-0">
      <div class="login-bg">
        <div class="left-content-area">
          <div class="card-content">
            <h2>{{ 'login.bannerText1' | translate }}</h2>
            <p>{{ 'login.bannerText2' | translate }}</p>
            <a
              class="btn mt-4 btn-login-info"
              href="https://safecloudsinglar.com/"
              target="_blank"
              type="button"
              >{{ 'login.bannerText3' | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 p-0">
      <div
        class="login-two-start"
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        "
      >
        <div class="logo-container">
          <img
            class="logo-safecloud-1"
            src="../../assets/img/safecloud-1.png"
            alt="logo"
          />
        </div>
        <h6 class="right-bar-heading px-3 mt-2 text-dark text-center font-30">
          {{ 'login.signIn' | translate }}
        </h6>

        <div class="login-two-inputs social-logins mt-4">
          <button
            (click)="loginMicrosoft()"
            type="button"
            class="btn btn-light px-3 py-2 d-flex justify-center"
            style="gap: 10px"
          >
            <img src="assets/images/ms.png" style="width: 24px" />
            <span>{{ 'login.signInMicrosoft' | translate }}</span>
          </button>
        </div>

        <form style="width: 80%; margin: 0 auto">
          <div class="login-two-inputs mt-5 input-group">
            <input
              type="email"
              class="form-control"
              [placeholder]="'login.emailOrUsername' | translate"
              (change)="setEmail($event)"
            />
            <i class="las la-user-alt"></i>
            <div class="invalid-feedback" *ngFor="let error of loginErrors">
              {{ error | translate }}
            </div>
          </div>
          <div class="login-two-inputs mt-4 input-group">
            <input
              type="password"
              class="form-control"
              [placeholder]="'login.password' | translate"
              style="background-color: #fff !important"
              (change)="setPassword($event)"
            />
            <i class="las la-lock"></i>
          </div>
          <div class="login-two-inputs mt-4 text-center d-flex">
            <button
              style="max-height: 40px"
              class="ripple-button ripple-button-primary btn-login ml-3 mr-3"
              (click)="login()"
            >
              <div class="ripple-ripple js-ripple">
                <span class="ripple-ripple__circle"></span>
              </div>
              <span *ngIf="!isLoading">{{ 'login.signIn' | translate }}</span>

              <div
                style="position: relative; top: -5px"
                class="d-flex justify-content-center loader"
                *ngIf="isLoading"
              >
                <div class="spinner-border" role="status">
                  <span class="sr-only">{{ 'login.loading' | translate }}</span>
                </div>
              </div>
            </button>
          </div>
        </form>
        <div class="mt-4 text-center font-12 strong">
          <a routerLink="/reset-password" class="text-primary">{{
            'login.forgotYourPassword' | translate
          }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
